import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import get from 'lodash/get';
import ApiService from '../../../services/apiService';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreDeviceTemplateEditTemplateInformation',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [iconsMixin],
  props: {
    template: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      default: null
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function data() {
    return {
      markdownEdit: false,
      formValid: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    scopeDetailledName: function scopeDetailledName() {
      var name = get(this.template, 'scope.name');
      var id = get(this.template, 'scope.id') || get(this.template, 'scopeId');

      if (id !== undefined) {
        return "".concat(name, " (ID ").concat(id, ")");
      }

      return name;
    }
  }),
  watch: {
    'template.tenantId': function templateTenantId() {
      this.fetchParents();
      this.$emit('formValidated', false);
    },
    template: {
      handler: function handler() {
        if (!this.template) {
          return;
        }

        this.$emit('formValidated', this.formValid);
      },
      deep: true
    },
    formValid: function formValid() {
      this.$emit('formValidated', this.formValid);
    }
  },
  methods: {
    get: get,
    parentSelectorFilter: function parentSelectorFilter(item, parentList) {
      var _this = this;

      return item.tenantId === this.template.tenantId && item.id !== this.template.id && parentList.findIndex(function (t) {
        return t.id === _this.template.id;
      }) === -1;
    },
    fetchParents: function fetchParents() {
      var _this2 = this;

      if (!this.template) {
        return;
      }

      ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, this.template.tenantId).then(function (result) {
        _this2.template.parentId = get(result, 'digitaltwins[0].id', null);
      }).catch(function (error) {
        console.error('Error fetching bridges', error);
      });
    }
  }
};